module.exports = __webpack_public_path__ + "static/teal_white-ec629f3d65e1701a57e926f1e275a6ac.png";